import React from 'react';
import { Table } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export function BoolColumn({ value }) {
  return <Table.BodyCellStatus status={value && value !== 'false' ? 'success' : 'error'} value="" />;
}

BoolColumn.propTypes = {
  value: PropTypes.string,
};
BoolColumn.defaultProps = {
  value: undefined,
};
